import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '../../services/authentication.service';
import { DataSharedService } from '../../services/data-shared.service';
import { TimesheetService } from '../../services/timesheet.service';
import { UserService } from '../../services/user.service';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SuccessModalComponent } from '../../components/success-modal/success-modal.component';
import { AccountGenerationLinkModalComponent } from '../../components/account-generation-link-modal/account-generation-link-modal.component';
import { SuccessModal } from '../../app.model';
import { Subscription } from 'rxjs';
import { EditUserComponent } from '../edit-user/edit-user.component';

@Component({
  selector: 'app-active-users',
  templateUrl: './active-users.component.html',
  styleUrls: ['./active-users.component.css']
})
export class ActiveUsersComponent implements OnInit {

  users: any = [];
  allUsers: any = [];
  loading: boolean = false;
  redirectedName!: string;
  totalCount: number = 0;
  userSearch: string = '';
  private subscription: Subscription;
  private modalRef: NgbModalRef;

  constructor(
    private timesheetService: TimesheetService,
    public authService: AuthenticationService,
    public dataSharedService: DataSharedService,
    public userService: UserService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private activeModalService: NgbActiveModal,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this.subscription = this.dataSharedService.getUpdate().subscribe((message) => {
      console.log(message);
      if (message.message == 'Updated Active Admin') {
        this.getAgencyUsers(1);
      }
    });

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.redirectedName = params?.name;
      this.getAgencyUsers(1);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async getAgencyUsers(page: number, search?: string) {
    this.users = [];
    this.allUsers = [];
    this.loading = true;
    this.timesheetService.getAgencyUsers(page, search, 1).subscribe((res: any) => {
      this.totalCount = res.meta.total;
      this.users = res.data.filter((x: any) => x.role === 'Agency Admin');
      if (this.redirectedName) {
        this.users = this.users.filter((x: any) => x.name === this.redirectedName);
      }
      this.loading = false;
      this.allUsers = this.users.slice();
    });
  }

  onStepChange(event: any) {
    this.getAgencyUsers(event)
  }

  searchUsers() {
    if (this.userSearch != '') {
      this.getAgencyUsers(1, this.userSearch);
    } else {
      this.getAgencyUsers(1);
    }
  }

  sortData(sort: Sort) {
    const data = this.users.slice();
    if (!sort.active || sort.direction === '') {
      this.allUsers = data;
      return;
    }

    this.allUsers = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'email':
          return compare(a.email, b.email, isAsc);
        case 'created_at':
          return compare(a.created_at, b.created_at, isAsc);
        default:
          return 0;
      }
    });
  }

  resendAccountActivation(candidateUuid: string) {
    const payload = {
      user_uuid: candidateUuid,
    }
    this.userService.resendUserLogin(payload).subscribe({
      next: (response) => {
        this.successModal('Account creation mail sent.')
      },
      error: (err) => {
      }
    });
  }

  onDeactivate(userUuid: string): void {
    this.userService.deactivateAccount(userUuid, {}).subscribe({
      next: (response) => {
        this.activeModalService.close({
          data: true,
        });
        this.successModal('Deactivated Successfully.');
        this.router.navigate(['/admins/inactive'])
      },
      error: (err) => {
      }
    });
  }

  generateAccountCreationLink(candidateUuid: string) {
    this.dialog.open(AccountGenerationLinkModalComponent, {
      width: '75%',
      maxWidth: '800px',
      maxHeight: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: 'timesheetDetailDialog',
      data: {
        userUuid: candidateUuid,
      },
    });
  }

  editUser(user: any) {
    this.modalRef = this.modalService.open(EditUserComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: "static",
      modalDialogClass: 'update-client-modal',
    });
    this.modalRef.componentInstance.user = user;
  }

  successModal(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });
    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 2000,
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}